import React from "react";

import Button from "../../../atoms/Button";

import styles from "./AssessmentDesc.module.scss";

export type Props = {
  onDirectToAssessment: () => void;
  isManager: boolean;
  onlyAssessment: boolean;
};

const AssessmentDesc: React.FC<Props> = ({
  onDirectToAssessment,
  isManager,
  onlyAssessment,
}) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <div className={styles.assessmentText}>ENAGEED GLIDE</div>
        <div className={styles.mainContent}>
          <p>
            自分の可能性を理解し、
            <br />
            誇りを持って生きるために
            <br />
            「未来をつくる力」の“現状”と
            <br />
            “成長に向けた次の経験”を把握する。
          </p>

          <Button
            name="ENAGEED GLIDEの内容と使い方"
            variant="outline"
            className={styles.tutorialBtn}
            onClick={() =>
              window.open(
                onlyAssessment
                  ? "https://www.enageed.jp/assessment-for-t-unintroduced"
                  : "https://www.enageed.jp/assessment-for-t",
                "_blank",
              )
            }
          />
          {!isManager && onlyAssessment && (
            <Button
              name="先生・クラス・生徒のご登録"
              variant="outline"
              className={styles.settingBtn}
              onClick={() =>
                window.open(
                  `${process.env.REACT_APP_MANAGER_URL}/manager/`,
                  "_blank",
                )
              }
            />
          )}
          <Button
            name="生徒のGLIDE結果を見る"
            variant="normal"
            className={styles.nextButton}
            onClick={onDirectToAssessment}
          />
        </div>
      </div>
    </div>
  );
};

export default AssessmentDesc;
